import React from "react";
import { Users } from "lucide-react";
import OpsTopBar from "../../components/ops/OpsTopBar";
import { OperatorAvatar } from "../../components/ops/BranchAvatar";
import useApi from "../../hooks/useApi";

const ROLE_LABEL = { operator: "Operator", team_leader: "Team Leader", manager: "Manager" };

export default function OpsTeam() {
  const { data } = useApi("/ops/operators");
  const operators = data?.operators || [];
  const maxActions = Math.max(1, ...operators.map((o) => o.expected_actions));

  return (
    <>
      <OpsTopBar title="Team" subtitle={`${operators.length} team members`} />
      <div className="p-6 sm:p-8 max-w-[1100px] space-y-4">
        <div className="grid sm:grid-cols-3 gap-4">
          {[
            ["Team members", operators.length],
            ["Branches managed", operators.reduce((s, o) => s + o.branches, 0)],
            ["Expected monthly actions", operators.reduce((s, o) => s + o.expected_actions, 0)],
          ].map(([l, v]) => (
            <div key={l} className="card p-5"><Users size={16} color="#5F8213" strokeWidth={1.75} /><div className="text-3xl font-extrabold tracking-tighter text-ink mt-2">{v}</div><div className="text-xs text-ink-2 mt-0.5">{l}</div></div>
          ))}
        </div>

        <div className="card overflow-hidden divide-y" style={{ borderColor: "#E7E8E4" }} data-testid="ops-team-list">
          {operators.map((o) => (
            <div key={o.id} className="flex items-center gap-4 px-5 py-4" data-testid={`operator-${o.id}`}>
              <OperatorAvatar initials={o.initials} color={o.color} size={40} />
              <div className="w-40 min-w-0">
                <div className="font-semibold text-ink truncate">{o.name}</div>
                <div className="text-xs text-ink-3">{ROLE_LABEL[o.role] || o.role}</div>
              </div>
              <div className="hidden sm:block text-sm text-ink-2 w-28">{o.branches} branches</div>
              <div className="flex-1">
                <div className="flex justify-between text-xs text-ink-2 mb-1"><span>Expected workload</span><span className="font-bold text-ink">{o.expected_actions} actions/mo</span></div>
                <div className="h-2 rounded-full overflow-hidden" style={{ background: "#EDEEE9" }}>
                  <div className="h-full rounded-full" style={{ width: `${Math.round((o.expected_actions / maxActions) * 100)}%`, background: o.color }} />
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-ink-3">Workload reflects each branch's managed package — not just branch count — so capacity planning stays accurate.</p>
      </div>
    </>
  );
}
